import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminButton from "components/admin/button"
import {AdminSelectContacts} from "components/contacts/select"
import {AdminSelectPlans} from "components/plans/select"
import AppHistory from "shared/history"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import {Form} from "@kaspernj/api-maker/build/form"
import memo from "set-state-compare/build/memo"
import React from "react"
import Routes from "shared/routes"
import {Subscription} from "models"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminSubscriptionsEdit extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.subscriptions.edit"})
    const params = useParams()
    const {subscription, subscriptionId} = useModel(Subscription, {
      match: {params},
      newIfNoId: true,
      select: {
        Subscription: ["contactId", "id", "planId"]
      }
    })

    this.setInstance({
      subscription,
      subscriptionId,
      t
    })

    this.useStates({
      form: null
    })
    useAdminLayout()?.setState({active: "subscriptions", headerTitle: this.headerTitle()})
  }

  render() {
    const {subscription} = this.tt

    return (
      <View dataSet={{route: "admin--subscriptions--edit"}}>
        {subscription &&
          <Form onSubmit={this.tt.onSubmit} setForm={this.setStates.form}>
            <View style={{marginBottom: 15}}>
              <AdminSelectPlans attribute="planId" label={Subscription.humanAttributeName("plan")} model={subscription} />
            </View>
            <View style={{marginBottom: 15}}>
              <AdminSelectContacts attribute="contactId" label={Subscription.humanAttributeName("contact")} model={subscription} />
            </View>
            <AdminButton primary save submit />
          </Form>
        }
      </View>
    )
  }

  headerTitle() {
    const {subscription} = this.tt

    if (subscription?.isNewRecord()) {
      return this.t(".add_new_subscription")
    } else if (subscription?.isPersisted()) {
      return this.t(".edit_subscription")
    }
  }

  onSubmit = async () => {
    const formData = this.s.form.asObject()
    const {subscription, t} = this.tt

    try {
      await subscription.saveRaw(formData)
      FlashMessage.success(t(".the_subscription_was_saved"))
      AppHistory.push(Routes.adminSubscriptionPath(subscription.id()))
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}))
